module.exports = __webpack_public_path__ + "static/pegasus-8de00e60be8ac7384cb1796750b3e106.svg";